<script lang="ts">
  import { BALANCE } from '@2k48/shared';
  import { tick } from 'svelte';
  import { createMotionScope, dur, gsap, prefersReducedMotion } from '../../game/motion';
  import { i18n } from '../i18n/index.svelte';

  interface Props {
    remainingMs: number;
  }

  let { remainingMs }: Props = $props();
  let beat: HTMLDivElement;
  let alive = true;
  let lastBeat = '';
  const scope = createMotionScope();

  const readyHold = $derived(
    remainingMs > BALANCE.phases.countdownMs - BALANCE.phases.countdownReadyHoldMs,
  );
  const digit = $derived(
    readyHold ? null : Math.min(3, Math.max(1, Math.ceil(remainingMs / 1000))),
  );
  const beatKey = $derived(readyHold ? 'ready' : String(digit));
  const litDots = $derived(digit === null ? 0 : 4 - digit);

  $effect(() => {
    const nextBeat = beatKey;
    if (nextBeat === lastBeat) return;
    lastBeat = nextBeat;

    void tick().then(() => {
      if (!alive || !beat) return;
      scope.add(() => {
        gsap.killTweensOf(beat);
        if (prefersReducedMotion()) {
          gsap.fromTo(beat, { opacity: 0 }, { opacity: 1, duration: dur(0.1), ease: 'none' });
          return;
        }
        gsap.fromTo(
          beat,
          { opacity: 0, scale: 0.62 },
          { opacity: 1, scale: 1, duration: dur(0.24), ease: 'back.out(2.8)' },
        );
      });
    });
  });

  $effect(() => () => {
    alive = false;
    scope.destroy();
  });
</script>

<div class="battle-countdown">
  <span class="battle-countdown__ready">{i18n.t.battle.ready}</span>
  <div class="battle-countdown__beat" bind:this={beat}>
    {#if readyHold}
      <strong class="battle-countdown__standby">{i18n.t.battle.steady}</strong>
    {:else}
      <strong class="battle-overlay__count">{digit}</strong>
    {/if}
  </div>
  <div class="battle-countdown__steps" aria-hidden="true">
    {#each { length: 3 } as _, index (index)}
      <i class:battle-countdown__step--lit={index < litDots}></i>
    {/each}
  </div>
</div>
